import { EntityService } from '../../../service/EntityService';

import { AppStorage } from '../../../service/UserStorage';

export class PartnerService extends EntityService {

  static entity = 'api/app/partner';

  static create(data: any): Promise<any> {
    data.tenantCompanyId = AppStorage.get('tenant');
    return super.create(data);
  }

  static update(id: string, data: any): Promise<any> {
    data.tenantCompanyId = AppStorage.get('tenant');
    return super.update(id, data);
  }

  static getAll(): Promise<any> {
    return this.axios.get(`${this.entity}/all`).then(res => res.data);
  }
}
